var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M37.802,23.247l-26.286-23C11.1-0.116,10.47-0.074,10.105,0.342c-0.363,0.415-0.321,1.047,0.094,1.411 L35.624,24L10.199,46.247c-0.416,0.364-0.458,0.996-0.094,1.411C10.303,47.885,10.58,48,10.858,48c0.233,0,0.468-0.081,0.658-0.247 l26.286-23c0.216-0.191,0.341-0.465,0.341-0.753S38.019,23.437,37.802,23.247z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.dcf7ffcd4262eacd7d478ecc0389e4f7.svg";
export { ForwardRef as ReactComponent };